import Icon from '@atoms/Icon/Icon';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

interface Props
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  readonly open?: boolean;
  readonly loadMoreLabel: string;
  readonly loadLessLabel?: string;
  readonly _type?: 'BASIC' | 'YELLOW-HIGHLIGHT';
  readonly isLightMode?: boolean;
  readonly dataTestId?: string;
}

const LoadMoreButton = ({
  open = false,
  loadMoreLabel,
  loadLessLabel,
  _type = 'BASIC',
  isLightMode,
  dataTestId,
  ...props
}: Props) => (
  <button
    className={classNames(
      'z-10 flex cursor-pointer flex-row items-center justify-center gap-4',
      _type === 'YELLOW-HIGHLIGHT' && open
        ? 'text-yellow underline decoration-1 underline-offset-4'
        : `text-black-100 ${isLightMode ? '' : 'dark:text-white'}`
    )}
    data-testid={dataTestId}
    {...props}
  >
    {(!open || loadLessLabel) && (
      <p className="h6">{open ? loadLessLabel : loadMoreLabel}</p>
    )}

    <motion.span
      animate={{
        rotate: open ? -180 : 0,
      }}
    >
      <Icon name="downArrow" size="1.25rem" colorClassName="text-yellow" />
    </motion.span>
  </button>
);

export default LoadMoreButton;
